import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Observer from '@researchgate/react-intersection-observer';
import cx from 'classnames';
import { updateChapter } from '../../services/store';
import Video from '../Video';
import Column from '../Column';
import './style.css';

class Chapter extends Component {
  onEnter = ({ isIntersecting }) => {
    const { updateChapter, title, id, onEnter } = this.props;

    if (isIntersecting) {
      updateChapter(title);
      onEnter(id);
    }
  }

  render() {
    const { title, children, media, theme } = this.props;

    return (
      <Observer onChange={this.onEnter}>
        <section className={cx('chapter', { [`chapter--${theme}`]: true })}>
          {media && (
            <div className="chapter__media">
              <Video src={media} width="960" height="540" />
            </div>
          )}
          <Column>
            {title && <h2 className="chapter__title">{title}</h2>}
            <div className="chapter__content">
              {children}
            </div>
          </Column>
        </section>
      </Observer>
    );
  }
}

Chapter.propTypes = {
  media: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  updateChapter: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['default', 'green', 'red']),
};

Chapter.defaultProps = {
  theme: 'default',
  onEnter: () => {},
};

export default connect(null, { updateChapter })(Chapter);



// WEBPACK FOOTER //
// ./src/components/Chapter/index.js